var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-loader',{attrs:{"height":35,"width":270,"speed":2,"primaryColor":"#f3f3f3","secondaryColor":"#e1e1e1"}},[_c('rect',{attrs:{"x":"8","y":"7.55","rx":"0","ry":"0","width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }